import { uniq } from 'lodash';

type LanguagesType = {
  [key: string]: string;
};

export const formatDate = (date: Date | string, lang: string): string => {
  if (isNaN(Number(date))) return '';

  const languages: LanguagesType = {
    en: 'en-GB',
    de: 'de-DE',
    es: 'es-ES',
    'zh-CN': 'zh-CN',
  };

  const newDate = new Date(date);
  const currentLanguage = languages[lang] || 'en-GB';
  const formattedDate = new Intl.DateTimeFormat(currentLanguage, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(newDate);

  const esFormattedDate = uniq(formattedDate.split(' ')).join(' ');

  if (languages.es.includes(lang)) return esFormattedDate;
  else return formattedDate;
};

export const setTitle = (tag: string | null, date: string | null) => {
  if (tag && date) return `${tag} - ${date}`;
  if (tag) return tag;
  if (date) return date;
  return '-';
};
